import React from "react";
import DesktopNavbar from "./DesktopNavbar";
import { useMediaQuery } from "react-responsive";
import MobileNavbar from "./MobileNavbar";
export function Header() {
  const isMobile = useMediaQuery({ maxWidth: 768 });

  return <div>{isMobile ? <MobileNavbar /> : <DesktopNavbar />}</div>;
}
